import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../services/axiosInstance';

const initialState = {
  items: [],
  loading: false,
  actionLoading: false,
  error: null,
  success: false,
};

// Async Thunks
export const fetchDeletedItems = createAsyncThunk(
  'restore/fetchDeletedItems',
  async (type, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(`/admin/restore-center/${type}`);
      if (res.data.success) {
        return res.data.items;
      }
      return rejectWithValue(`Failed to fetch deleted ${type} items`);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const restoreItem = createAsyncThunk(
  'restore/restoreItem',
  async ({ type, id }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.patch(`/admin/restore-center/${type}/${id}/restore`);
      if (res.data.success) {
        return { id, message: res.data.message };
      }
      return rejectWithValue('Failed to restore item');
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const permanentlyDeleteItem = createAsyncThunk(
  'restore/permanentlyDeleteItem',
  async ({ type, id }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.delete(`/admin/restore-center/${type}/${id}/permanent`);
      if (res.data.success) {
        return { id, message: res.data.message };
      }
      return rejectWithValue('Failed to permanently delete item');
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const restoreSlice = createSlice({
  name: 'restore',
  initialState,
  reducers: {
    clearRestoreSuccess: (state) => {
      state.success = false;
    },
    clearRestoreError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchDeletedItems
      .addCase(fetchDeletedItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeletedItems.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchDeletedItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // restoreItem
      .addCase(restoreItem.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(restoreItem.fulfilled, (state, action) => {
        state.items = state.items.filter(item => item._id !== action.payload.id);
        state.actionLoading = false;
        state.success = true;
      })
      .addCase(restoreItem.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
        state.success = false;
      })

      // permanentlyDeleteItem
      .addCase(permanentlyDeleteItem.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(permanentlyDeleteItem.fulfilled, (state, action) => {
        state.items = state.items.filter(item => item._id !== action.payload.id);
        state.actionLoading = false;
        state.success = true;
      })
      .addCase(permanentlyDeleteItem.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { clearRestoreSuccess, clearRestoreError } = restoreSlice.actions;
export default restoreSlice.reducer;
